import tenant from '@/helpers/Tenant'
import type { CardBrand } from '@/types/TenantConfig'
import type { PaymentMethod, StripeCardElementChangeEvent } from '@stripe/stripe-js'

/**
 * Only USOPM uses this feature.
 */
export function cardIsAllowed(card: PaymentMethod.Card | StripeCardElementChangeEvent): boolean {
  // Always allow unknown brands.
  // TODO Is this desirable behavior?
  if (card.brand === 'unknown') return true

  // Only restrict cards if there is a list of allowed card brands
  if (!tenant.allowedCardBrands) return true

  // StripeCardElementChangeEvent['brand'] lists the possible values of card brands, but
  // PaymentMethod does not; PaymentMethod.Card['brand'] is specified simply as `string` even
  // though documentation states that the only possible values are amex, diners, discover,
  // jcb, mastercard, unionpay, visa, and unknown.
  //
  // @see https://stripe.com/docs/api/payment_methods/object#payment_method_object-card-brand
  return tenant.allowedCardBrands.includes(card.brand as CardBrand)
}
